module.exports = __webpack_public_path__ + "static/media/view lesson plan.316f2c97.svg";